// Schema names (region_id, fact_finance_monthly, table.column) printed inside
// prose: each set as code, with a break opportunity after every _ and . so a
// narrow card wraps it at a joint, never in the middle of a token.
import { Fragment, type ReactNode } from "react";

const IDENT = /\b[a-z][a-z0-9]*(?:[_.][a-z0-9]+)+\b/g;

/** One identifier as code, breakable only after its joints. */
export function Ident({ name }: { name: string }) {
  const parts = name.split(/(?<=[_.])/);
  return (
    <code className="viz-code" data-raw="">
      {parts.map((part, i) => (
        <Fragment key={i}>
          {part}
          {i < parts.length - 1 ? <wbr /> : null}
        </Fragment>
      ))}
    </code>
  );
}

/** Prose with every schema name inside it set as an identifier. */
export function rawText(text: string): ReactNode {
  const out: ReactNode[] = [];
  let at = 0;
  for (const m of text.matchAll(IDENT)) {
    const i = m.index ?? 0;
    if (i > at) out.push(text.slice(at, i));
    out.push(<Ident key={i} name={m[0]} />);
    at = i + m[0].length;
  }
  if (at < text.length) out.push(text.slice(at));
  return out.length === 1 && typeof out[0] === "string" ? out[0] : <>{out}</>;
}
